var _path, _path2, _path3, _path4, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRps2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 117,
    viewBox: "0 0 158 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 67L46 86.1648",
    stroke: "black",
    strokeWidth: 1.97587,
    strokeDasharray: "2.98 2.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100H47",
    stroke: "black",
    strokeWidth: 1.97587,
    strokeDasharray: "2.98 2.98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9357 79.6836H11.1313V89.488H20.9357V79.6836Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 116.357V100.412H27.3225V116.357",
    stroke: "black",
    strokeWidth: 8.9073,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4812_7455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.809,
    y: 105.236,
    width: 41.236,
    height: 1.44688,
    rx: 0.723438,
    transform: "rotate(-90 116.809 105.236)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.725,
    y: 105.236,
    width: 41.236,
    height: 1.44688,
    rx: 0.723439,
    transform: "rotate(-90 132.725 105.236)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.533 98.1006L117.533 102.857L123.286 101.575C123.58 101.51 123.812 101.276 123.879 100.982C124.006 100.427 124.01 99.843 123.888 99.2865C123.816 98.9615 123.544 98.7189 123.213 98.6849L117.533 98.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.533 98.1006L117.533 102.857L123.286 101.575C123.58 101.51 123.812 101.276 123.879 100.982C124.006 100.427 124.01 99.843 123.888 99.2865C123.816 98.9615 123.544 98.7189 123.213 98.6849L117.533 98.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.533 98.1006L117.533 102.857L123.286 101.575C123.58 101.51 123.812 101.276 123.879 100.982C124.006 100.427 124.01 99.843 123.888 99.2865C123.816 98.9615 123.544 98.7189 123.213 98.6849L117.533 98.1006Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.607 98.1006L133.607 102.857L128.446 101.592C128.136 101.516 127.898 101.269 127.833 100.957L127.829 100.94C127.718 100.407 127.716 99.8561 127.823 99.3216C127.892 98.9762 128.176 98.7151 128.526 98.6755L133.607 98.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.607 98.1006L133.607 102.857L128.446 101.592C128.136 101.516 127.898 101.269 127.833 100.957L127.829 100.94C127.718 100.407 127.716 99.8561 127.823 99.3216C127.892 98.9762 128.176 98.7151 128.526 98.6755L133.607 98.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.607 98.1006L133.607 102.857L128.446 101.592C128.136 101.516 127.898 101.269 127.833 100.957L127.829 100.94C127.718 100.407 127.716 99.8561 127.823 99.3216C127.892 98.9762 128.176 98.7151 128.526 98.6755L133.607 98.1006Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.903 78.3259C113.18 78.1513 116.102 78.0687 118.458 78.0299C119.635 78.0104 120.67 78.0019 121.41 77.9983C121.781 77.9965 122.077 77.9959 122.281 77.9957L122.347 77.9957L122.347 83.2828C122.258 83.2826 122.146 83.2823 122.013 83.2818C121.635 83.2805 121.085 83.2777 120.399 83.2723C119.027 83.2613 117.11 83.2394 114.93 83.1956C110.568 83.1079 105.157 82.9326 100.949 82.5826C100.926 82.5807 100.904 82.5788 100.881 82.577C100.299 82.5288 99.6392 82.4742 99.1148 82.2719C98.8465 82.1685 98.6322 82.0327 98.4854 81.8554C98.3424 81.6825 98.25 81.4541 98.25 81.1356C98.25 80.7966 98.5154 80.483 99.0069 80.2012C100.36 79.4257 101.95 79.2264 103.57 79.0234C103.844 78.989 104.119 78.9546 104.393 78.9172C106.078 78.6881 107.756 78.5624 109.741 78.4136C110.117 78.3855 110.503 78.3565 110.903 78.3259Z",
    fill: "black",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.078 78.3259C137.802 78.1513 134.88 78.0687 132.524 78.0299C131.346 78.0104 130.311 78.0019 129.571 77.9983C129.201 77.9965 128.904 77.9959 128.7 77.9957L128.635 77.9957L128.635 83.2828C128.724 83.2826 128.836 83.2823 128.969 83.2818C129.347 83.2805 129.896 83.2777 130.582 83.2723C131.954 83.2613 133.871 83.2394 136.051 83.1956C140.413 83.1079 145.824 82.9326 150.033 82.5826C150.055 82.5807 150.078 82.5788 150.1 82.577C150.682 82.5288 151.342 82.4742 151.867 82.2719C152.135 82.1685 152.349 82.0327 152.496 81.8554C152.639 81.6825 152.731 81.4541 152.731 81.1356C152.731 80.7966 152.466 80.483 151.975 80.2012C150.621 79.4257 149.031 79.2264 147.411 79.0234C147.138 78.989 146.863 78.9546 146.588 78.9172C144.903 78.6881 143.226 78.5624 141.24 78.4136C140.865 78.3855 140.478 78.3565 140.078 78.3259Z",
    fill: "black",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.788 81.265C121.815 83.1547 122.777 86.6614 123.694 89.5953C124.241 91.3446 126.549 91.3737 127.113 89.6299C128.012 86.8514 128.919 83.4957 128.919 81.265C128.919 76.8422 128.045 68.3705 125.353 68.3705C122.662 68.3705 121.72 76.7177 121.788 81.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.788 81.265C121.815 83.1547 122.777 86.6614 123.694 89.5953C124.241 91.3446 126.549 91.3737 127.113 89.6299C128.012 86.8514 128.919 83.4957 128.919 81.265C128.919 76.8422 128.045 68.3705 125.353 68.3705C122.662 68.3705 121.72 76.7177 121.788 81.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.788 81.265C121.815 83.1547 122.777 86.6614 123.694 89.5953C124.241 91.3446 126.549 91.3737 127.113 89.6299C128.012 86.8514 128.919 83.4957 128.919 81.265C128.919 76.8422 128.045 68.3705 125.353 68.3705C122.662 68.3705 121.72 76.7177 121.788 81.265Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4812_7455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.8096,
    y: 41.2363,
    width: 41.236,
    height: 1.44688,
    rx: 0.723438,
    transform: "rotate(-90 50.8096 41.2363)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.7251,
    y: 41.2363,
    width: 41.236,
    height: 1.44688,
    rx: 0.723439,
    transform: "rotate(-90 66.7251 41.2363)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5331 34.1006L51.5331 38.8574L57.2861 37.5752C57.5805 37.5096 57.8119 37.2763 57.8791 36.9823C58.0062 36.4269 58.0103 35.843 57.8879 35.2865C57.8164 34.9615 57.5445 34.7189 57.2134 34.6849L51.5331 34.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5331 34.1006L51.5331 38.8574L57.2861 37.5752C57.5805 37.5096 57.8119 37.2763 57.8791 36.9823C58.0062 36.4269 58.0103 35.843 57.8879 35.2865C57.8164 34.9615 57.5445 34.7189 57.2134 34.6849L51.5331 34.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5331 34.1006L51.5331 38.8574L57.2861 37.5752C57.5805 37.5096 57.8119 37.2763 57.8791 36.9823C58.0062 36.4269 58.0103 35.843 57.8879 35.2865C57.8164 34.9615 57.5445 34.7189 57.2134 34.6849L51.5331 34.1006Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6072 34.1006L67.6072 38.8574L62.4455 37.592C62.136 37.5161 61.8977 37.2691 61.8328 36.9572L61.8293 36.9403C61.7183 36.4067 61.7162 35.8561 61.8231 35.3216C61.8921 34.9762 62.1764 34.7151 62.5264 34.6755L67.6072 34.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6072 34.1006L67.6072 38.8574L62.4455 37.592C62.136 37.5161 61.8977 37.2691 61.8328 36.9572L61.8293 36.9403C61.7183 36.4067 61.7162 35.8561 61.8231 35.3216C61.8921 34.9762 62.1764 34.7151 62.5264 34.6755L67.6072 34.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6072 34.1006L67.6072 38.8574L62.4455 37.592C62.136 37.5161 61.8977 37.2691 61.8328 36.9572L61.8293 36.9403C61.7183 36.4067 61.7162 35.8561 61.8231 35.3216C61.8921 34.9762 62.1764 34.7151 62.5264 34.6755L67.6072 34.1006Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9032 14.3259C47.1795 14.1513 50.1015 14.0687 52.4577 14.0299C53.6351 14.0104 54.67 14.0019 55.4104 13.9983C55.7806 13.9965 56.0772 13.9959 56.2812 13.9957L56.3469 13.9957L56.3469 19.2828C56.2578 19.2826 56.1459 19.2823 56.0126 19.2818C55.6346 19.2805 55.085 19.2777 54.3991 19.2723C53.0273 19.2613 51.1103 19.2394 48.93 19.1956C44.568 19.1079 39.1573 18.9326 34.9489 18.5826C34.9265 18.5807 34.9039 18.5788 34.8813 18.577C34.2994 18.5288 33.6392 18.4742 33.1148 18.2719C32.8465 18.1685 32.6322 18.0327 32.4854 17.8554C32.3424 17.6825 32.25 17.4541 32.25 17.1356C32.25 16.7966 32.5154 16.483 33.0069 16.2012C34.36 15.4257 35.9501 15.2264 37.57 15.0234C37.8439 14.989 38.1187 14.9546 38.3933 14.9172C40.0781 14.6881 41.7557 14.5624 43.741 14.4136C44.1167 14.3855 44.5034 14.3565 44.9032 14.3259Z",
    fill: "black",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0782 14.3259C71.8019 14.1513 68.8799 14.0687 66.5237 14.0299C65.3463 14.0104 64.3115 14.0019 63.571 13.9983C63.2008 13.9965 62.9042 13.9959 62.7003 13.9957L62.6346 13.9957L62.6346 19.2828C62.7236 19.2826 62.8356 19.2823 62.9688 19.2818C63.3469 19.2805 63.8965 19.2777 64.5824 19.2723C65.9542 19.2613 67.8711 19.2394 70.0514 19.1956C74.4135 19.1079 79.8241 18.9326 84.0325 18.5826C84.0549 18.5807 84.0775 18.5788 84.1002 18.577C84.682 18.5288 85.3422 18.4742 85.8667 18.2719C86.1349 18.1685 86.3493 18.0327 86.496 17.8554C86.6391 17.6825 86.7314 17.4541 86.7314 17.1356C86.7314 16.7966 86.466 16.483 85.9745 16.2012C84.6215 15.4257 83.0313 15.2264 81.4114 15.0234C81.1375 14.989 80.8627 14.9546 80.5881 14.9172C78.9034 14.6881 77.2257 14.5624 75.2404 14.4136C74.8648 14.3855 74.4781 14.3565 74.0782 14.3259Z",
    fill: "black",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7875 17.265C55.8155 19.1547 56.7766 22.6614 57.6939 25.5953C58.2408 27.3446 60.5488 27.3737 61.1131 25.6299C62.0123 22.8514 62.9195 19.4957 62.9195 17.265C62.9195 12.8422 62.0448 4.37051 59.3535 4.37051C56.6622 4.37051 55.7202 12.7177 55.7875 17.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7875 17.265C55.8155 19.1547 56.7766 22.6614 57.6939 25.5953C58.2408 27.3446 60.5488 27.3737 61.1131 25.6299C62.0123 22.8514 62.9195 19.4957 62.9195 17.265C62.9195 12.8422 62.0448 4.37051 59.3535 4.37051C56.6622 4.37051 55.7202 12.7177 55.7875 17.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7875 17.265C55.8155 19.1547 56.7766 22.6614 57.6939 25.5953C58.2408 27.3446 60.5488 27.3737 61.1131 25.6299C62.0123 22.8514 62.9195 19.4957 62.9195 17.265C62.9195 12.8422 62.0448 4.37051 59.3535 4.37051C56.6622 4.37051 55.7202 12.7177 55.7875 17.265Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4812_7455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.8093,
    y: 72.2363,
    width: 41.236,
    height: 1.44688,
    rx: 0.723438,
    transform: "rotate(-90 86.8093 72.2363)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.725,
    y: 72.2363,
    width: 41.236,
    height: 1.44688,
    rx: 0.723439,
    transform: "rotate(-90 102.725 72.2363)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5328 65.1006L87.5328 69.8574L93.2859 68.5752C93.5803 68.5096 93.8116 68.2763 93.8789 67.9823C94.0059 67.4269 94.01 66.843 93.8876 66.2865C93.8161 65.9615 93.5442 65.7189 93.2132 65.6849L87.5328 65.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5328 65.1006L87.5328 69.8574L93.2859 68.5752C93.5803 68.5096 93.8116 68.2763 93.8789 67.9823C94.0059 67.4269 94.01 66.843 93.8876 66.2865C93.8161 65.9615 93.5442 65.7189 93.2132 65.6849L87.5328 65.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5328 65.1006L87.5328 69.8574L93.2859 68.5752C93.5803 68.5096 93.8116 68.2763 93.8789 67.9823C94.0059 67.4269 94.01 66.843 93.8876 66.2865C93.8161 65.9615 93.5442 65.7189 93.2132 65.6849L87.5328 65.1006Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.607 65.1006L103.607 69.8574L98.4455 68.592C98.136 68.5161 97.8977 68.2691 97.8328 67.9572L97.8293 67.9403C97.7183 67.4067 97.7162 66.8561 97.8231 66.3216C97.8921 65.9762 98.1764 65.7151 98.5264 65.6755L103.607 65.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.607 65.1006L103.607 69.8574L98.4455 68.592C98.136 68.5161 97.8977 68.2691 97.8328 67.9572L97.8293 67.9403C97.7183 67.4067 97.7162 66.8561 97.8231 66.3216C97.8921 65.9762 98.1764 65.7151 98.5264 65.6755L103.607 65.1006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.607 65.1006L103.607 69.8574L98.4455 68.592C98.136 68.5161 97.8977 68.2691 97.8328 67.9572L97.8293 67.9403C97.7183 67.4067 97.7162 66.8561 97.8231 66.3216C97.8921 65.9762 98.1764 65.7151 98.5264 65.6755L103.607 65.1006Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9032 45.3259C83.1795 45.1513 86.1015 45.0687 88.4577 45.0299C89.6351 45.0104 90.67 45.0019 91.4104 44.9983C91.7806 44.9965 92.0772 44.9959 92.2812 44.9957L92.3469 44.9957L92.3469 50.2828C92.2578 50.2826 92.1459 50.2823 92.0126 50.2818C91.6346 50.2805 91.085 50.2777 90.3991 50.2723C89.0273 50.2613 87.1103 50.2394 84.93 50.1956C80.568 50.1079 75.1573 49.9326 70.9489 49.5826C70.9265 49.5807 70.9039 49.5788 70.8813 49.577C70.2994 49.5288 69.6392 49.4742 69.1148 49.2719C68.8465 49.1685 68.6322 49.0327 68.4854 48.8554C68.3424 48.6825 68.25 48.4541 68.25 48.1356C68.25 47.7966 68.5154 47.483 69.0069 47.2012C70.36 46.4257 71.9501 46.2264 73.57 46.0234C73.8439 45.989 74.1187 45.9546 74.3933 45.9172C76.0781 45.6881 77.7557 45.5624 79.741 45.4136C80.1167 45.3855 80.5034 45.3565 80.9032 45.3259Z",
    fill: "black",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.078 45.3259C107.802 45.1513 104.88 45.0687 102.524 45.0299C101.346 45.0104 100.311 45.0019 99.571 44.9983C99.2008 44.9965 98.9042 44.9959 98.7003 44.9957L98.6346 44.9957L98.6346 50.2828C98.7236 50.2826 98.8356 50.2823 98.9688 50.2818C99.3469 50.2805 99.8965 50.2777 100.582 50.2723C101.954 50.2613 103.871 50.2394 106.051 50.1956C110.413 50.1079 115.824 49.9326 120.033 49.5826C120.055 49.5807 120.078 49.5788 120.1 49.577C120.682 49.5288 121.342 49.4742 121.867 49.2719C122.135 49.1685 122.349 49.0327 122.496 48.8554C122.639 48.6825 122.731 48.4541 122.731 48.1356C122.731 47.7966 122.466 47.483 121.975 47.2012C120.621 46.4257 119.031 46.2264 117.411 46.0234C117.138 45.989 116.863 45.9546 116.588 45.9172C114.903 45.6881 113.226 45.5624 111.24 45.4136C110.865 45.3855 110.478 45.3565 110.078 45.3259Z",
    fill: "black",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7875 48.265C91.8155 50.1547 92.7766 53.6614 93.6939 56.5953C94.2408 58.3446 96.5488 58.3737 97.1131 56.6299C98.0123 53.8514 98.9195 50.4957 98.9195 48.265C98.9195 43.8422 98.0448 35.3705 95.3535 35.3705C92.6622 35.3705 91.7202 43.7177 91.7875 48.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7875 48.265C91.8155 50.1547 92.7766 53.6614 93.6939 56.5953C94.2408 58.3446 96.5488 58.3737 97.1131 56.6299C98.0123 53.8514 98.9195 50.4957 98.9195 48.265C98.9195 43.8422 98.0448 35.3705 95.3535 35.3705C92.6622 35.3705 91.7202 43.7177 91.7875 48.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7875 48.265C91.8155 50.1547 92.7766 53.6614 93.6939 56.5953C94.2408 58.3446 96.5488 58.3737 97.1131 56.6299C98.0123 53.8514 98.9195 50.4957 98.9195 48.265C98.9195 43.8422 98.0448 35.3705 95.3535 35.3705C92.6622 35.3705 91.7202 43.7177 91.7875 48.265Z",
    stroke: "#CFCCCC",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4812_7455",
    x: 97,
    y: 64,
    width: 60.9814,
    height: 48.2363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4812_7455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4812_7455",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4812_7455",
    x: 31,
    y: 0,
    width: 60.9814,
    height: 48.2363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4812_7455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4812_7455",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4812_7455",
    x: 67,
    y: 31,
    width: 60.9814,
    height: 48.2363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4812_7455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4812_7455",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRps2);
export default __webpack_public_path__ + "static/media/RPS2.d3977991.svg";
export { ForwardRef as ReactComponent };